const fetchConfig = (type = "json") => {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  }
}

const safeFetch = async (...params) => {
  let response, error

  try {
    response = await fetch(...params)
  } catch (e) {
    error = e
  }

  return {
    response,
    error,
  }
}

const scrollLock = (lock = false) => {
  // compensate for scrollbarwidth so page doesn't jump when we hide the scroll bar
  const scrollBarWidth = window.innerWidth - document.body.offsetWidth

  const header = document.getElementById("nav-wrapper")

  if (lock) {
    document.body.classList.add("no-scroll")
    document.body.style.paddingRight = scrollBarWidth + "px"
    header.style.paddingRight = scrollBarWidth + "px"
  } else {
    document.body.classList.remove("no-scroll")
    document.body.style.paddingRight = "0px"
    header.style.paddingRight = "0px"
  }
}

const scrollLockViewport = (lock = false, viewport) => {
  if (lock) {
    document.body.classList.add(`no-scroll--${viewport}`)
  } else {
    document.body.classList.remove(`no-scroll--${viewport}`)
  }
}

let escCallBack = () => {}

const escFunction = (event) => {
  if (event.key === "Escape") {
    escCallBack()
    window.removeEventListener("keydown", escFunction)
  }
}

// this enables and disables listening for an ESC button
const escListener = (enable = false, callbackFunction) => {
  // we pass a callback function that executes when we hit ESC
  if (callbackFunction) {
    escCallBack = callbackFunction
  }

  if (enable) {
    window.addEventListener("keydown", escFunction)
  }

  if (!enable) {
    window.removeEventListener("keydown", escFunction)
  }
}

// debounce

function debounce(fn, wait) {
  const _this = this

  let t
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key]
    }

    clearTimeout(t)
    t = setTimeout(function () {
      return fn.apply(_this, args)
    }, wait)
  }
}

// throttle

function throttle(fn, wait) {
  let timerFlag = null

  return (...args) => {
    if (timerFlag === null) {
      fn(...args)
      timerFlag = setTimeout(() => {
        timerFlag = null
      }, wait)
    }
  }
}

// advanced throttle
// allows the most recent arguments to be used when the throttle window expires
// to use with window resize and mouse move events

function advancedThrottle(fn, wait) {
  let timerFlag = null
  let waitingArgs
  const timeoutFunc = () => {
    if (waitingArgs == null) {
      timerFlag = null
    } else {
      fn(...waitingArgs)
      waitingArgs = null
      setTimeout(timeoutFunc, wait)
    }
  }

  return (...args) => {
    if (timerFlag) {
      waitingArgs = args
      return
    }

    fn(...args)
    timerFlag = setTimeout(timeoutFunc, wait)
  }
}

// scroll

function scrollTo(scrollToElement, gap = 0) {
  const headerEl = document.getElementById("nav-wrapper")
  const headerUXPosition = document.querySelector(".header").getAttribute("data-ux-position")
  const scrollToElementTopOffset = scrollToElement.getBoundingClientRect().top

  window.scrollTo({
    top:
      headerUXPosition !== "off"
        ? scrollToElementTopOffset + window.scrollY - gap + parseFloat(headerEl.style.marginTop)
        : scrollToElementTopOffset + window.scrollY - gap,
    behavior: "smooth",
  })
}

document.querySelectorAll(".local-scroll").forEach((el) => {
  el.addEventListener("click", (e) => {
    e.preventDefault()
    e.stopPropagation()
    const id = e.target.getAttribute("href")
    const scrollToElement = document.querySelector(id)
    scrollTo(scrollToElement)
  })
})

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      'summary, a[href], button:not([disabled]), [tabindex]:not([tabindex^="-"]), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe',
    ),
  )
}

const trapFocusHandlers = {}

function trapFocus(container, elementToFocus = container) {
  const elements = getFocusableElements(container)
  const first = elements[0]
  const last = elements[elements.length - 1]

  removeTrapFocus()

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) {
      return
    }

    document.addEventListener("keydown", trapFocusHandlers.keydown)
  }

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown)
  }

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault()
      first.focus()
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault()
      last.focus()
    }
  }

  document.addEventListener("focusout", trapFocusHandlers.focusout)
  document.addEventListener("focusin", trapFocusHandlers.focusin)

  elementToFocus.focus()
}

function removeTrapFocus(elementToFocus) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin)
  document.removeEventListener("focusout", trapFocusHandlers.focusout)
  document.removeEventListener("keydown", trapFocusHandlers.keydown)

  if (elementToFocus) elementToFocus.focus()
}

const updateColumnCount = () => {
  const el = document.querySelector(".grid-archive__content")
  const cols = document.querySelector(".grid-archive__subnav .cols")

  if (cols) {
    document.querySelectorAll(".view-icon-desktop").forEach((icon) => {
      icon.onclick = function () {
        document.querySelectorAll(".view-icon-desktop").forEach((icon) => {
          icon.classList.remove("active")
        })
        this.classList.add("active")
        localStorage.setItem("columns-desktop", icon.dataset.columns)
        if (icon.dataset.columns == 4) {
          el.classList.remove("grid-archive__content--three-column")
          el.classList.add("grid-archive__content--four-column")
        } else {
          el.classList.add("grid-archive__content--three-column")
          el.classList.remove("grid-archive__content--four-column")
        }
      }
    })

    document.querySelectorAll(".view-icon-mobile").forEach((icon) => {
      icon.onclick = function () {
        document.querySelectorAll(".view-icon-mobile").forEach((icon) => {
          icon.classList.remove("active")
        })
        this.classList.add("active")
        localStorage.setItem("columns-mobile", icon.dataset.columns)
        if (icon.dataset.columns == 1) {
          el.classList.remove("grid-archive__content--two-column")
          el.classList.add("grid-archive__content--one-column")
        } else {
          el.classList.add("grid-archive__content--two-column")
          el.classList.remove("grid-archive__content--one-column")
        }
      }
    })

    if (localStorage.getItem("columns-desktop") == 4) {
      el.classList.remove("grid-archive__content--three-column")
      el.classList.add("grid-archive__content--four-column")
      document.querySelector(".three-col").classList.remove("active")
      document.querySelector(".four-col").classList.add("active")
    }

    if (localStorage.getItem("columns-mobile") == 1) {
      el.classList.remove("grid-archive__content--two-column")
      el.classList.add("grid-archive__content--one-column")
      document.querySelector(".two-col").classList.remove("active")
      document.querySelector(".one-col").classList.add("active")
    }
  }
}

const isInViewport = (element, buffer = 120) => {
  const rect = element.getBoundingClientRect()
  const html = document.documentElement

  return (
    rect.top >= -buffer &&
    rect.left >= -buffer &&
    rect.bottom <= (window.innerHeight || html.clientHeight) + buffer &&
    rect.right <= (window.innerWidth || html.clientWidth) + buffer
  )
}

const onWindowResize = (fn) => {
  // Store the window width
  let windowWidth = window.innerWidth

  const resizeHandler = () => {
    if (window.innerWidth !== windowWidth) {
      fn()

      // Update the window width for next time
      windowWidth = window.innerWidth
    }
  }

  // Store the function reference on the `fn` object for later removal
  fn._resizeHandler = resizeHandler

  window.addEventListener("resize", resizeHandler)
}

const removeOnWindowResize = (fn) => {
  if (fn._resizeHandler) {
    window.removeEventListener("resize", fn._resizeHandler)

    // Clean up reference
    delete fn._resizeHandler
  }
}

export {
  fetchConfig,
  scrollLock,
  scrollLockViewport,
  escListener,
  debounce,
  throttle,
  advancedThrottle,
  scrollTo,
  trapFocus,
  removeTrapFocus,
  updateColumnCount,
  safeFetch,
  isInViewport,
  onWindowResize,
  removeOnWindowResize,
}
